module.exports = __webpack_public_path__ + "img/lisa-kepinski.jpg?15815730a1b2b54e62f8a6fdc8ff748c";